import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Broadcaster() {
  const navigate = useNavigate();
  const [btnHover, setBtnHover] = useState(false);

  return (
    <div style={{
      minHeight: '100vh', background: '#0a0a0a', color: '#ffffff',
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '40px 24px', position: 'relative',
    }}>
      {/* Back link */}
      <div style={{ position: 'absolute', top: 24, left: 28 }}>
        <button
          onClick={() => navigate('/gateway')}
          style={{
            background: 'transparent', border: 'none', color: '#6b7280',
            fontSize: 14, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, padding: 0,
          }}
          onMouseEnter={e => e.currentTarget.style.color = '#f97316'}
          onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
        >
          ← Back to Gateway
        </button>
      </div>

      {/* Logo */}
      <div style={{ position: 'absolute', top: 16, right: 28 }}>
        <img src="/maxxcom-logo.png" alt="MAXXCOM" style={{ height: 36, objectFit: 'contain' }} />
      </div>

      {/* Content */}
      <div style={{ textAlign: 'center', maxWidth: 560 }}>
        <div style={{ fontSize: 80, marginBottom: 24, lineHeight: 1 }}>📢</div>

        <div style={{
          display: 'inline-block', padding: '5px 16px', borderRadius: 100,
          border: '1px solid #2a2a2a', background: '#111111',
          fontSize: 12, color: '#f97316', fontWeight: 700, letterSpacing: 1,
          textTransform: 'uppercase', marginBottom: 20,
        }}>
          Coming Soon
        </div>

        <h1 style={{ fontSize: 42, fontWeight: 900, color: '#ffffff', marginBottom: 16, letterSpacing: '-1px' }}>
          Broadcaster
        </h1>

        <p style={{ fontSize: 16, color: '#9ca3af', lineHeight: 1.8, marginBottom: 12 }}>
          The WhatsApp Broadcaster lets you send bulk messages, manage lists, and run campaigns.
        </p>

        <p style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.7, marginBottom: 40 }}>
          We're putting the finishing touches on this feature. Schedule broadcasts, manage audience lists,
          run drip campaigns, and track delivery rates — all from one place.
          Sit tight, it's launching soon!
        </p>

        <div style={{
          background: '#111111', border: '1px solid #1f1f1f', borderRadius: 16,
          padding: '24px 32px', marginBottom: 36, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20,
        }}>
          {[
            { icon: '📋', label: 'Bulk Messaging' },
            { icon: '📅', label: 'Campaign Scheduling' },
            { icon: '📊', label: 'Delivery Analytics' },
          ].map(item => (
            <div key={item.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>{item.icon}</div>
              <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 500 }}>{item.label}</div>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate('/app')}
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{
            padding: '13px 32px', borderRadius: 10, border: 'none',
            background: btnHover ? '#ea580c' : '#f97316',
            color: '#fff', fontSize: 15, fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s',
          }}
        >
          Go to Bot Admin
        </button>
      </div>
    </div>
  );
}
